import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IDatePlace } from "src/app/models/location.model";
import { DateService } from "src/app/services/date/date.service";
import { SaleService } from "src/app/services/sale/sale.service";



@Component({
  selector: "dates-places-chip-panel",
  templateUrl: "./dates-places-chip-panel.component.html",
  styleUrls: ["./dates-places-chip-panel.component.scss"]
})
export class DatesPlacesChipPanelComponent implements OnInit {

  @Input('items')
  set items(value:IDatePlace[]){
    for(const item of value){
      if(item.geocoding && value[0].geocoding && item.geocoding.locationID !== value[0].geocoding.locationID){
        this.showPlaces = true;
      }
      if(item.name && value[0].name && item.name !== value[0].name){
        // console.log(item.name, value[0].name)
        this.showNames = true;
      }
    }
    // console.log('show place', this.showPlaces);
    // console.log('show name', this.showNames);
    this._items = value;
  }

  showPlaces = false;

  showNames = false;

  _items: IDatePlace[];

  @Input()
  selectType: string;

  @Input()
  defaultIcon: string;

  @Input()
  required: boolean;

  @Input()
  deliveryType: string;

  keyword:string;

  @Output() clicked = new EventEmitter<any>();


  constructor(public dateService:DateService, public saleService:SaleService ) {
  }

  ngOnInit(): void {}

  onClick(itemClicked){
    if(this.selectType == 'multi'){
      itemClicked.selected = !itemClicked.selected; 
    }
    else {
      for(const item of this._items){
        if(item.key !== itemClicked.key){
          item.selected = false;
        }
        else{
          item.selected = !item.selected;
        }
      }
    }
    this.clicked.emit(itemClicked);
  }
}
